





















































































import { Vue, Component, Watch, Ref } from "vue-property-decorator";
import ScormView from "@/components/courses/ScormView.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import { getCurrentUserId } from "@/plugins/roles";
import courseRegistrations, {
  CourseRegistrationsListParams
} from "@/getinfo-api/courseRegistrations";
import {
  Course as ICourse,
  LearningUnit as ILearningUnit,
  Registration as IRegistration
} from "@/api-v2/course/models";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({ components: { Modal, CustomButton, CPage, ScormView } })
export default class Lesson extends Vue {
  @Ref("scorm-view") scormView!: ScormView;
  courseRegistration!: IRegistration;
  course!: ICourse;
  learningUnit!: ILearningUnit;
  learningUnits!: Array<ILearningUnit>;
  canMoveOn: boolean = false;
  canMoveBack: boolean = false;
  lessonIndex!: number;
  isLoading: boolean = false;

  data() {
    return {
      course: undefined,
      courseRegistration: undefined,
      learningUnit: undefined,
      learningUnits: undefined,
      lessonIndex: undefined
    };
  }

  get userId() {
    return getCurrentUserId();
  }

  get lessonId() {
    return this.$route.params.id;
  }

  @Watch("lessonId")
  changeRoute() {
    this.getCourseRegistration();
  }

  getCourseRegistration() {
    this.isLoading = true;
    const params: CourseRegistrationsListParams = {
      courseIds: [this.$route.params.courseId],
      studentUserIds: [this.userId],
      statuses: ["learning"]
    };
    courseRegistrations(params)
      .then(res => {
        if (res.data.items.length) {
          [this.courseRegistration] = res.data.items;
          this.course = this.courseRegistration.course;
          this.learningUnits = this.course.learningUnits.filter(
            el => el.objectType === "Lesson"
          );
          this.lessonIndex = this.learningUnits.findIndex(
            el => el.id === this.$route.params.id
          );
          this.learningUnit = this.learningUnits[this.lessonIndex];

          this.canMoveBack = this.lessonIndex !== 0;
          this.canMoveOn = this.lessonIndex !== this.learningUnits.length - 1;
        } else {
          this.$store.dispatch(
            "localError",
            `${this.$tc(
              this.$translate.TheUserIsNotAnActiveStudentInTheCourse
            )}`
          );
          this.$router.push({
            name: "course",
            params: { id: this.$route.params.courseId }
          });
        }
      })
      .finally(() => {
        this.isLoading = false;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  changeMoveOn(event: any) {
    this.canMoveOn = event;
    this.canMoveOn = this.lessonIndex !== this.learningUnits.length - 1;
  }

  terminateLesson() {
    this.scormView.terminateSession();
    this.$router.push({
      name: "course",
      params: { id: this.$route.params.courseId }
    });
  }

  next() {
    this.lessonIndex++;
    this.$router.push({
      name: "lesson",
      params: {
        courseId: this.$route.params.courseId,
        id: this.learningUnits[this.lessonIndex].id
      }
    });
  }

  back() {
    this.lessonIndex--;
    this.$router.push({
      name: "lesson",
      params: {
        courseId: this.$route.params.courseId,
        id: this.learningUnits[this.lessonIndex].id
      }
    });
  }

  created() {
    this.getCourseRegistration();
  }
}
